import React, { Component } from 'react'
import { Route, Switch, BrowserRouter as Router} from 'react-router-dom'
import queryString from 'query-string'

import { PaginationContext } from '../../context/pagination'
import { NextDisabledContext } from '../../context/nextDisabled'

import Welcome1 from './welcome_p1'
import WelcomeDeclined from './welcome_declined'
import Genetics from './genetics'
import FetchWrapper from '../../utils/fetch_wrapper'

import config from '../../utils/config'

class Welcome extends Component {
  constructor(props) {
    super(props)
    this.state = { 
      verError: false,
      loading: true,
      nextDisabled: false
    }
    this.updateActivePage = this._updateActivePage.bind(this)
    document.title = "Welcome Page"
  }

  static getPageCount(displayGenetics) {
    if (displayGenetics) {
      return 2
    }
    return 1
  }

  _updateActivePage(n) {
    this.context.updateActivePage(this.props.match.path, n)
  }

  async componentDidMount() {
    const plId = queryString.parse(window.location.search).plId
    await this.props.getStepCompleted(plId)
    this.setState({ loading: false })
  }

  componentDidUpdate() {
    if (this.shouldRedirect()) {
      let result = this.props.setShouldRedirect(true)
      if (result) this.setState({ nextDisabled: false })
    } else {
      this.props.setShouldRedirect(false)
    }
  }

  confirmDeclined() {
    if(window.confirm("Please confirm that you decided not to continue to the program.")) {
      return true
    }
    return false
  }

  async _nextPage(history, cur, state) {
    let { nextStep } = state.input
    let verified = false
    let disabled = false
    const plId = queryString.parse(history.location.search).plId
    if (this.state.nextDisabled) return null
    if ((nextStep && nextStep.value === 'ready') || cur === '/genetics') disabled = true 
    this.setState({
      nextDisabled: disabled,
      verError: false
    }, async () => {
      switch(cur) {
        case '/':
          await this.props.getStepCompleted(plId)
          if (window.location.pathname !== '/welcome') return null
          if (nextStep.value === 'ready') {
            verified = await this.processWelcome(state, history) 
            if (verified) {
              if (this.props.displayGenetics) {
                await this.props.getStepCompleted(plId)
                return history.push('/genetics' + history.location.search)
              } else {
                await this.updateStepCompleted(history, 'WelcomeConfirmed', '/questionnaire')
                return this.props.next()
              }
            }
          } else if (nextStep.value === 'decline') {
            if(this.confirmDeclined()) {
              this.setState({ nextDisabled: true })
              verified = await this.processWelcome(state, history) 
              if (verified) {
                await this.props.getStepCompleted(plId)
                return history.push('/declined' + history.location.search)
              }  
            } else {
              this.setState({ nextDisabled: false })
            }
          }
          break
        case '/genetics':
          await this.props.getStepCompleted(plId)
          if (window.location.pathname !== '/welcome/genetics') return null
          verified = await this.processGenetic(state, history)
          if (verified) {
            return this.props.next()
          }
          break
        default:
          return null
      }
    })
  }

  async updateStepCompleted(history, stepCompleted, nextStepUrl) {
    const code = queryString.parse(history.location.search)
    nextStepUrl = window.location.origin + nextStepUrl
    const params = {
      plId : parseInt(code.plId),
      RegCode: code.regCode,
      NextStepUrl: nextStepUrl,
      StepCompleted: stepCompleted
    }   
    try { 
      let response = await FetchWrapper.fetch(config.endpoint_updateStepCompleted, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(params)
      })

      const { status } = response
      if (status !== 'success') {
        this.setState({
          nextDisabled: false
        })
      }
      return true
    } catch (error) {
      this.setState({
        nextDisabled: false
      })
      return false 
    }
  }

  async processWelcome(state, history) {
    const { nextStep } = state.input
    const code = queryString.parse(history.location.search)
    let params = {
      plId: parseInt(code.plId),
      regCode: code.regCode,
      answer: nextStep.value,
      nextStepUrl: window.location.origin
    }

    try {
      let response = await FetchWrapper.fetch(config.endpoint_process_welcome, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(params)
      })

      const { status } = response
      if(status !== 'success') {
        this.setState({
          nextDisabled: false
        })
      }
      this.setState({ verError: false })
      return true
    } catch(error) {
      this.setState({
        verError: true,
        nextDisabled: false
      })
      return false
    }
  }

  async processGenetic(state, history) {
    const { geneticConsent, geneticConsentInitial, geneticReleaseCheck, geneticReleaseInitial } = state.input
    const code = queryString.parse(history.location.search)
    let params = {
      plId:  parseInt(code.plId),
      regCode: code.regCode,
      geneticConsent: 'decline',
      geneticConsentSignature: '',
      geneticInfoRelease: false,
      geneticInfoReleaseSignature: '',
      nextStepUrl: window.location.origin
    }

    if (geneticConsent.value === 'agree') {
      params.geneticConsent = 'agree'
      params.geneticConsentSignature = geneticConsentInitial.value
      params.geneticInfoRelease = geneticReleaseCheck.value
      params.geneticInfoReleaseSignature = geneticReleaseInitial.value
    }

    try {
      let response = await FetchWrapper.fetch(config.endpoint_process_genetic, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(params)
      })
      
      const { status } = response
      if(status !== 'success') {
        this.setState({
          nextDisabled: false
        })
      }

      this.setState({ verError: false })
      return true
    } catch(error) {
      this.setState({
        verError: true,
        nextDisabled: false
      })
      return false
    }
  }

  shouldRedirect() {
    if (!this.props.nextStepPath) return true
    const n = this.props.nextStepPath.search('\\?')
    let nextPath = this.props.nextStepPath.substring(0, n)
    if ((nextPath === '/welcome' && window.location.pathname === '/welcome') || 
        (nextPath === '/welcome/genetics' && window.location.pathname === '/welcome/genetics') || 
        (nextPath === '/welcome/declined' && window.location.pathname === '/welcome/declined')) {
      return false
    }
    return true
  }

  extendRoute(R) {
    return props => {
      return <R 
        {... props}
        updateActivePage={this.updateActivePage}
        next={this._nextPage.bind(this, props.history)}
        verError={this.state.verError}
        displayGenetics={this.props.displayGenetics}
        welcomeVideo={this.props.welcomeVideo}
      />
    }
  }

  render() {
    if (this.state.loading) return <div></div>
    return (
      <div id="welcome">
        <NextDisabledContext.Provider value={this.state.nextDisabled}>
          <Router basename={this.props.match.path}>
            <Switch>
              <Route exact path="/" render={this.extendRoute(Welcome1)} />
              <Route exact path="/declined" render={this.extendRoute(WelcomeDeclined)} />
              <Route exact path="/genetics" render={this.extendRoute(Genetics)} />
            </Switch>
          </Router>
        </NextDisabledContext.Provider>
      </div>
    )
  }
}
Welcome.contextType = PaginationContext


export default Welcome